// extracted by mini-css-extract-plugin
module.exports = {"firstName":"CreateAccountInviteForm_firstName__3FHEv","createAccount":"CreateAccountInviteForm_createAccount__3mFGf"};